import ImageBlock from './ImageBlock';
export default ImageBlock;
